let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("joJy8"), load("aHE9G"), load("kSVGa")]).then(() => parcelRequire('5BDEU'));